/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsForCustomSaasTool extends models.ServiceAccountNativeDetailsBaseForSaasOtherServices {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsForCustomSaasTool");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsForCustomSaasTool.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsForCustomSaasTool>): ServiceAccountNativeDetailsForCustomSaasTool {
        let obj = Object.assign(new ServiceAccountNativeDetailsForCustomSaasTool(), model);
        ServiceAccountNativeDetailsForCustomSaasTool.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsForCustomSaasTool>): ServiceAccountNativeDetailsForCustomSaasTool {
        if (!model) return null;
        return ServiceAccountNativeDetailsForCustomSaasTool.newInstance(<ServiceAccountNativeDetailsForCustomSaasTool> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsForCustomSaasTool) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsForCustomSaasTool.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsForCustomSaasTool): boolean {
        if (models.ServiceAccountNativeDetailsBaseForSaasOtherServices.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsForCustomSaasTool.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Tool Name.
     */
    tool_name: string;

    /**
     * Description about the tool.
     */
    tool_description: string;

    /**
     * File Path for Logo.
     */
    tool_logo_file_path: string;

}
